export default class SheetsCareplanModel {
  constructor () {
    this.id = 0
    this.date = ''
    this.caregiver = ''
    this.records = []
    this.createdAt = ''
    this.shiftType = ''
    this.submitStatus = ''
  }

  static fromJSON (json) {
    let sheet = new SheetsCareplanModel()
    sheet.id = json.id
    sheet.date = json.date
    sheet.caregiver = json.caregiver
    sheet.records = json.records
    sheet.createdAt = json.createdAt
    sheet.shiftType = json.shiftType
    sheet.submitStatus = json.submitStatus
    return sheet
  }
}
